import { useSuspenseQuery } from "@tanstack/react-query";
import api from "../../../../../services/api";

const useEmailAttachments = (hashValue: string, relationshipID: number) => {
  const extractedFilesQP = {
    view_type: "FLAT",
    page_size: 5,
    page: 1,
    relationship: relationshipID
  };
  const { data: attachmentsData } = useSuspenseQuery({
    queryKey: ["attachments", hashValue, extractedFilesQP],
    queryFn: () =>
      api.getExtractedAttachments({
        hashValue,
        extractedFilesQP
      }),
    select: ({ data }) => data
  });

  return {
    results: attachmentsData.results,
    attachmentsPath: attachmentsData.attachments_root
  };
};

export default useEmailAttachments;
